<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-10-26 14:52:49
 * @LastEditors: pj
 * @LastEditTime: 2022-10-28 11:51:28
-->
<template>
    <div>
        <a-card size="small" title="平台类型">
            <!-- <a-button slot="extra" type="primary" @click="handleNew">新增</a-button> -->
        </a-card>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="platformtypeTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'

export default {
    data() {
        return {
            searchP: {
                keyword: '',
            },
        }
    },
    methods: {
        handleSubmit(searchP) {
            this.$refs.platformtypeTableID.handleSearch(searchP)
        },

        handleNew() {
            this.$router.push({
                path: 'add_platformtype',
                query: { id: '' },
            })
        },
    },
    components: {
        tableE,
        searchE,
    },
    mounted() {},
}
</script>
<style scoped>
</style>
